import React, { useState } from "react";
import HeaderNavBar from "../HeaderNavBar";
import { useSelector } from "react-redux";
// import FirstStepsNotLoggedIn2 from "../FirstSteps2/FirstStepsNotLoggedIn2";
import { isInDevelopment } from "../../config";
import { Row, Col } from "react-bootstrap";
import logo from "../../images/logo_ekbo_neu_farbig.svg";

// logo_ekbo_neu_farbig

function StartPage() {
  // console.log();
  const [showFirstSteps, setShowFirstSteps] = useState(true);
  const currentUser = useSelector((st) => st.currentUser);
  const loggedIn = !!currentUser?.username;
  // console.log('inside StartPage', {loggedIn})
  return (
    <div className="App container">
      <header
        className="App-header jumbotron mt-1 py-md-4"
        id="jumbo"
        style={{ backgroundColor: "rgba(255,255,255,.05)" }}
      >
        {/* <h3 className="App-title display-5" ></h3> */}
        <Row className="text-center">
          <Col>
            <img
              src={logo}
              alt="Logo Klausurgutachten Berlin"
              style={{ width: "30%" }}
            />
          </Col>

        </Row>
        {isInDevelopment && (
          <div className="p-3 my-3" style={{ border: "1px solid grey" }}>
            <>
              <h4>Developer-Modus</h4>
              <p>
                Dieser wird nur kurzfristig angezeigt, während das Projekt in
                der Entwicklung ist.
              </p>
              <p>
                Einige Angaben sind nur für den Entwickler gedacht. Sie haben
                für den Benutzer keine Bedeutung.
              </p>
            </>
          </div>
        )}
        {(!showFirstSteps || loggedIn) && (
          <nav>
            <HeaderNavBar />
          </nav>
        )}
        {/* <div className="mt-md-2"><AdvertisementArea /></div> */}
        <div className="text-center">
          {/* {!loggedIn && showFirstSteps && <FirstStepsNotLoggedIn2 setShowFirstSteps={setShowFirstSteps}/>} */}
        </div>
      </header>
    </div>
  );
}

export default StartPage;
